export default {"src":"/_next/static/media/fingerprint-light.462680bb.svg","height":700,"width":500,"blurWidth":0,"blurHeight":0};